import { Pipe, PipeTransform } from '@angular/core';

/**
 * MockTranslatePipe
 * - returns the input value
 */
@Pipe({ name: 'translate' })
export class MockTranslatePipe implements PipeTransform {
  transform(value: any, ...args: any[]): any {
    return value; // Gibt einfach den Eingabewert zurück
  }
}
